
import React from 'react';
import { H2, NamedLink } from '../../../components';
import css from './FeaturedArticleCard.module.css';

// Featured Article Card Component
const FeaturedArticleCard = ({ listing, intl, config }) => {
  const { title, publicData } = listing.attributes;
  const subtitle = publicData?.subtitle || '';
  const author = listing.author?.attributes?.profile?.displayName || intl.formatMessage({ id: 'ArticlesPage.unknownAuthor' });
  const createdAt = listing.attributes.createdAt;
  const formattedDate = intl.formatDate(createdAt, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

  const firstImage = listing.images && listing.images.length > 0 ? listing.images[0] : null;

  return (
    <NamedLink
      name="ListingPage"
      params={{ id: listing.id.uuid, slug: listing.attributes.title }}
      className={css.featuredCard}
    >
      {firstImage && (
        <div className={css.featuredImageWrapper}>
          <div className={css.aspectWrapper}>
            <img
              src={firstImage.attributes.variants['scaled-large']?.url || firstImage.attributes.variants['default']?.url}
              alt={title}
              className={css.featuredImage}
            />
          </div>
        </div>
      )}
      <div className={css.featuredContent}>
        <H2 as="h2" className={css.featuredTitle}>
          {title}
        </H2>
        {subtitle && <p className={css.featuredSubtitle}>{subtitle}</p>}
        <div className={css.featuredMeta}>
          <span className={css.author}>{author}</span>
          <span className={css.separator}>-</span>
          <span className={css.date}>{formattedDate}</span>
        </div>
      </div>
    </NamedLink>
  );
};


export default FeaturedArticleCard;